module.exports = "/_next/static/resources/array-c6300015a32666bba947ced155e95cf1.webp";